import { siteMessages } from 'src/features/sites/utils/messages';
import { SITE_TYPE, COUNTRY_MAP } from 'src/features/sites/utils/types';
import { BadgeOptions } from 'src/registry/types/badges';
import { ICON_MAP } from 'src/utils/constants';
import { generalMessages } from 'src/utils/messages';

export const siteBadgeOptions: BadgeOptions = {
    [SITE_TYPE.PUBLIC]: {
        label: siteMessages.public,
        icon: ICON_MAP.SQUARE_PARKING,
        theme: 'green',
    },
    [SITE_TYPE.PRIVATE]: {
        label: siteMessages.private,
        icon: ICON_MAP.KEY,
        theme: 'red',
    },
    [SITE_TYPE.COMMERCIAL]: {
        label: siteMessages.commercial,
        icon: ICON_MAP.SHOP,
        theme: 'gray',
    },
    [SITE_TYPE.RESIDENTIAL]: {
        label: siteMessages.residential,
        icon: ICON_MAP.RESIDENT,
        theme: 'blue',
    },
};

export const SITE_TRANSLATION_MAP = {
    [SITE_TYPE.PUBLIC]: siteMessages.public,
    [SITE_TYPE.PRIVATE]: siteMessages.private,
    [SITE_TYPE.COMMERCIAL]: siteMessages.commercial,
    [SITE_TYPE.RESIDENTIAL]: siteMessages.residential,
};

export const COUNTRY_TRANSLATION_MAP = {
    [COUNTRY_MAP.BG]: siteMessages.bulgaria,
};

export const BOOLEAN_MAP = {
    true: generalMessages.yes,
    false: generalMessages.no,
};

export const BOOLEAN_OPTIONS = ['true', 'false'];
